type CheckoutResponse = {
  checkoutUrl?: unknown;
  redirectUrl?: unknown;
};

export function getPaymentCheckoutUrl(response: unknown): string | null {
  if (!response || typeof response !== 'object') return null;

  const { checkoutUrl, redirectUrl } = response as CheckoutResponse;
  const candidate = typeof checkoutUrl === 'string'
    ? checkoutUrl
    : typeof redirectUrl === 'string'
      ? redirectUrl
      : '';

  if (!candidate) return null;

  try {
    const url = new URL(candidate);
    return url.protocol === 'https:' ? url.toString() : null;
  } catch {
    return null;
  }
}